import { render, staticRenderFns } from "./DocumentSearchPanel.vue?vue&type=template&id=bb152b56&"
import script from "./DocumentSearchPanel.vue?vue&type=script&lang=ts&"
export * from "./DocumentSearchPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports